import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function QualificationSection() {
  return <Section background="light" className="relative" data-id="element-197">
      <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-198">
        {/* For You If */}
        <div className="space-y-8" data-id="element-199">
          <h2 className="text-3xl font-serif font-bold text-[#0f1923]" data-id="element-200">
            Esto es para ti si...
          </h2>
          <ul className="space-y-4" data-id="element-201">
            {['Apagar pantallas en tu casa siempre termina mal.', "Te prometiste 'mañana lo ordeno' y han pasado meses.", 'Tu hijo se pone irritable o muy alterado cuando le quitas el celular/tablet.', 'Sientes culpa porque a veces usas la pantalla para poder trabajar/descansar.', 'Has intentado prohibir, negociar o castigar… y todo regresa.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-202">
                <div className="mt-1 bg-[#c9a84c]/20 p-1 rounded-full" data-id="element-203">
                  <Check className="w-5 h-5 text-[#c9a84c]" data-id="element-204" />
                </div>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-205">{item}</p>
              </li>)}
          </ul>
        </div>

        {/* Not For You If */}
        <div className="space-y-8 p-8 bg-white rounded-2xl shadow-sm border border-gray-100" data-id="element-206">
          <h2 className="text-3xl font-serif font-bold text-[#0f1923]" data-id="element-207">
            Lo que este plan NO es
          </h2>
          <ul className="space-y-4" data-id="element-208">
            {['No es un sermón.', 'No es un curso teórico.', 'No es una lista interminable de consejos.', "No es 'cero pantallas para siempre'."].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-209">
                <div className="mt-1 bg-red-100 p-1 rounded-full" data-id="element-210">
                  <X className="w-5 h-5 text-red-500" data-id="element-211" />
                </div>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-212">{item}</p>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-10 text-center max-w-3xl mx-auto" data-id="element-213">
        <p className="text-2xl font-serif italic text-[#1a2332] leading-relaxed" data-id="element-214">
          "Este plan es un sistema operativo familiar: reglas simples,
          reemplazos reales y consistencia que puedes sostener incluso cuando
          estás cansado."
        </p>
      </div>
    </Section>;
}